import * as React from 'react';
import PropTypes from 'prop-types';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';
import { MaxCharlimit, MaxCharlimitShort } from '../../../utils/helper';
import { CommonInputData as data } from '../../../utils/pageContent';

const CommonInput = ({
  id,
  name,
  value,
  label,
  error,
  type,
  onChange,
  disabled,
  isRequired,
  isIcon,
  autoComplete,
  placeholder,
  classNames,
  isLengthValidate,
  isShort = false
}) => {
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium dark:text-white text-gray-700">
        {label} {isRequired && !disabled && <span className="text-red-400">&#42;</span>}
        {isLengthValidate && !disabled && (
          <span className="mt-1 float-right text-xs text-red-400">
            {!isShort &&
              (value?.length <= MaxCharlimit
                ? MaxCharlimit - value?.length + data.charactersLeftText
                : data.outOfCharacterLimit100)}
            {isShort &&
              (value?.length <= MaxCharlimitShort
                ? MaxCharlimitShort - value?.length + data.charactersLeftText
                : data.outOfCharacterLimit25)}
          </span>
        )}
      </label>
      <div className="relative">
        <div className="mt-1">
          <input
            id={id}
            name={name}
            value={value}
            type={showEyeIcon ? 'text' : type}
            onChange={onChange}
            disabled={disabled}
            placeholder={placeholder}
            autoComplete={autoComplete}
            className={`block w-full rounded-input appearance-none border border-gray-300 ${
              classNames ? classNames : 'px-3 py-[9px]'
            } text-[14px] placeholder-gray-400 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:text-white focus:border-shoorah-primary focus:outline-none focus:ring-shoorah-primary leading-5`}
          />
        </div>
        {isIcon &&
          (showEyeIcon ? (
            <EyeSlashIcon
              onClick={() => setShowEyeIcon(false)}
              className={`cursor-pointer absolute w-[20px] text-shoorah-primary dark:text-white top-1/2 transform -translate-y-1/2 ${
                classNames ? 'right-[13px]' : 'right-[10px]'
              }`}
            />
          ) : (
            <EyeIcon
              onClick={() => setShowEyeIcon(true)}
              className={`cursor-pointer absolute w-[20px] text-shoorah-primary dark:text-white top-1/2 transform -translate-y-1/2 ${
                classNames ? 'right-[13px]' : 'right-[10px]'
              }`}
            />
          ))}
      </div>
      {isRequired && <span className="error text-xs text-red-400">{error}</span>}
    </div>
  );
};

CommonInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  classNames: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isIcon: PropTypes.bool,
  isShort: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  isLengthValidate: PropTypes.any
};
export default CommonInput;
